import { render } from "./ReferenceIdAutocomplete.vue?vue&type=template&id=10a570b5&scoped=true"
import script from "./ReferenceIdAutocomplete.vue?vue&type=script&lang=js"
export * from "./ReferenceIdAutocomplete.vue?vue&type=script&lang=js"

import "./ReferenceIdAutocomplete.vue?vue&type=style&index=0&id=10a570b5&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.7\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a570b5"]])

export default __exports__